// Orders
import OrderBrand from "./cdp/orders/OrderBrand";
import OrderCity from "./cdp/orders/OrderCity";
import OrderClimaticFeature from "./cdp/orders/OrderClimaticFeature";
import OrderCountry from "./cdp/orders/OrderCountry";
import OrderDateAndHour from "./cdp/orders/OrderDateAndHour";
import OrderDay from "./cdp/orders/OrderDay";
import OrderDayWeek from "./cdp/orders/OrderDayWeek";
import OrderDeliveryFee from "./cdp/orders/OrderDeliveryFee";
import OrderMoisture from "./cdp/orders/OrderMoisture";
import OrderMonth from "./cdp/orders/OrderMonth";
import OrderNeighborhood from "./cdp/orders/OrderNeighborhood";
import OrderOriginSale from "./cdp/orders/OrderOriginSale";
import OrderSourceData from "./cdp/orders/OrderSourceData";
import OrderState from "./cdp/orders/OrderState";
import OrderTemperature from "./cdp/orders/OrderTemperature";
import OrderThermalSensation from "./cdp/orders/OrderThermalSensation";
import OrderUnit from "./cdp/orders/OrderUnit";
import OrderValue from "./cdp/orders/OrderValue";
import OrderWeek from "./cdp/orders/OrderWeek";
import OrderYear from "./cdp/orders/OrderYear";

// Customers
import CustomerAverageTicket from "./cdp/customers/CustomerAverageTicket";
import CustomerBirthday from "./cdp/customers/CustomerBirthday";
import CustomerDateAndHour from "./cdp/customers/CustomerDateAndHour";
import CustomerDayRegistration from "./cdp/customers/CustomerDayRegistration";
import CustomerDayWeekRegistration from "./cdp/customers/CustomerDayWeekRegistration";
import CustomerDoc from "./cdp/customers/CustomerDoc";
import CustomerEmail from "./cdp/customers/CustomerEmail";
import CustomerFrequencyOrders from "./cdp/customers/CustomerFrequencyOrders";
import CustomerGender from "./cdp/customers/CustomerGender";
import CustomerHourRegistration from "./cdp/customers/CustomerHourRegistration";
import CustomerLastAtt from "./cdp/customers/CustomerLastAtt";
import CustomerLastOrder from "./cdp/customers/CustomerLastOrder";
import CustomerMarketing from "./cdp/customers/CustomerMarketing";
import CustomerMonthRegistration from "./cdp/customers/CustomerMonthRegistration";
import CustomerName from "./cdp/customers/CustomerName";
import CustomerPhone from "./cdp/customers/CustomerPhone";
import CustomerQuantityOrders from "./cdp/customers/CustomerQuantityOrders";
import CustomerRFV from "./cdp/customers/CustomerRFV";
import CustomerTotalSpend from "./cdp/customers/CustomerTotalSpend";
import CustomerWeekRegistration from "./cdp/customers/CustomerWeekRegistration";
import CustomerYearRegistration from "./cdp/customers/CustomerYearRegistration";

// Coupons
import CouponCode from "./cdp/coupons/CouponCode";
import CouponDay from "./cdp/coupons/CouponDay";
import CouponDayAndHour from "./cdp/coupons/CouponDayAndHour";
import CouponDayWeek from "./cdp/coupons/CouponDayWeek";
import CouponDaysExp from "./cdp/coupons/CouponDaysExp";
import CouponDiscount from "./cdp/coupons/CouponDiscount";
import CouponExpDate from "./cdp/coupons/CouponExpDate";
import CouponExpDateReminder from "./cdp/coupons/CouponExpDateReminder";
import CouponHour from "./cdp/coupons/CouponHour";
import CouponMinOrder from "./cdp/coupons/CouponMinOrder";
import CouponMonth from "./cdp/coupons/CouponMonth";
import CouponType from "./cdp/coupons/CouponType";
import CouponWeek from "./cdp/coupons/CouponWeek";
import CouponYear from "./cdp/coupons/CouponYear";

// Products
import CustomerDaysWithoutConversion from "./cdp/customers/CustomerDaysWithoutConversion";
import ProductCategory from "./cdp/products/ProductCategory";
import ProductDay from "./cdp/products/ProductDay";
import ProductDayAndHour from "./cdp/products/ProductDayAndHour";
import ProductDayWeek from "./cdp/products/ProductDayWeek";
import ProductHour from "./cdp/products/ProductHour";
import ProductMonth from "./cdp/products/ProductMonth";
import ProductName from "./cdp/products/ProductName";
import ProductQuantity from "./cdp/products/ProductQuantity";
import ProductSKU from "./cdp/products/ProductSKU";
import ProductSize from "./cdp/products/ProductSize";
import ProductValue from "./cdp/products/ProductValue";
import ProductWeek from "./cdp/products/ProductWeek";
import ProductYear from "./cdp/products/ProductYear";
import ProfileClimate from "./cdp/profiles/ProfileClimate";
import ProfileMomentDay from "./cdp/profiles/ProfileMomentDay";
import ProfileMomentWeek from "./cdp/profiles/ProfileMomentWeek";
import ProfileRFV from "./cdp/profiles/ProfileRFV";
import ProfileSeason from "./cdp/profiles/ProfileSeason";
import ProfileTemperature from "./cdp/profiles/ProfileTemperature";
import CustomerAge from "./cdp/customers/CustomerAge";

export const CdpComponents = {
  // Orders
  OrderDateAndHour,
  OrderValue,
  OrderDeliveryFee,
  OrderBrand,
  OrderUnit,
  OrderSourceData,
  OrderOriginSale,
  OrderCity,
  OrderState,
  OrderCountry,
  OrderNeighborhood,
  OrderTemperature,
  OrderThermalSensation,
  OrderMoisture,
  OrderClimaticFeature,
  OrderYear,
  OrderDay,
  OrderWeek,
  OrderDayWeek,
  OrderMonth,
  // Customers
  CustomerAge,
  CustomerDateAndHour,
  CustomerName,
  CustomerEmail,
  CustomerPhone,
  CustomerDoc,
  CustomerBirthday,
  CustomerGender,
  CustomerLastAtt,
  CustomerTotalSpend,
  CustomerQuantityOrders,
  CustomerRFV,
  CustomerAverageTicket,
  CustomerFrequencyOrders,
  CustomerLastOrder,
  CustomerMarketing,
  CustomerHourRegistration,
  CustomerDayRegistration,
  CustomerWeekRegistration,
  CustomerDayWeekRegistration,
  CustomerYearRegistration,
  CustomerMonthRegistration,
  CustomerDaysWithoutConversion,
  // Coupons
  CouponDayAndHour,
  CouponCode,
  CouponType,
  CouponDiscount,
  CouponMinOrder,
  CouponDaysExp,
  CouponExpDate,
  CouponExpDateReminder,
  CouponHour,
  CouponDay,
  CouponWeek,
  CouponDayWeek,
  CouponMonth,
  CouponYear,
  // Products
  ProductDayAndHour,
  ProductSKU,
  ProductName,
  ProductQuantity,
  ProductHour,
  ProductValue,
  ProductSize,
  ProductCategory,
  ProductYear,
  ProductMonth,
  ProductDay,
  ProductWeek,
  ProductDayWeek,

  ProfileClimate,
  ProfileMomentDay,
  ProfileMomentWeek,
  ProfileRFV,
  ProfileSeason,
  ProfileTemperature,
};
